<!--
component: ListAttr
author: Takumi Ogura
description: 詳細検索結果リスト
-->
<template>
	<section class="list">
		<v-container fluid class="pt-0 px-0">
			<div class="head-message">{{ headMessage }}</div>
			<v-row class="pt-1 mt-0">
				<v-col>
					<v-card class="pb-3">
						<v-card-title class="pt-2">
							<v-row>
								<v-col class="d-flex align-center pb-0" :style="{'font-size': ($vuetify.breakpoint.name == ('xs' || 'sm') ? '0.90rem' : '1.25rem')}">
									{{ '検索条件に一致した結果が' + items.length + '件見つかりました。' }}
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<v-text-field
										v-model="search"
										append-icon="mdi-magnify"
										label="検索"
										@keyup="searchMod()"
										single-line
										hide-details
									>
									</v-text-field>
								</v-col>
							</v-row>
						</v-card-title>
						<v-row class="mx-2">
							<v-col id="dataTable">
								<v-data-table
									class="tableView elevation-1"
									:header-props="{'sort-icon': 'mdi-arrow-up-thin'}"
									:height="$vuetify.breakpoint.height - 320"
									:items-per-page="items.length"
									:headers="header"
									:items="items"
									item-key="daichoId"
									@click:row="clickRow"
									hide-default-footer
									no-data-text="検索結果はありません。"
									no-results-text="検索結果はありません。"
									:search="search"
									:mobile-breakpoint="0"
								>
								</v-data-table>
							</v-col>
						</v-row>
						<!-- ボタン群 -->
						<v-row justify="center">
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="selectedData == null" min-width="70%" @click="goListExamDisp()">審査処分経過</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="selectedData == null" min-width="70%" @click="goBrowseGaiyo()">概要書</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="!kisaiEnable" min-width="70%" @click="goBrowseDaicho()">台帳記載証明</v-btn>
							</v-col>
							<!-- TODO プロット図ボタン 一旦保留 -->
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="selectedData == null"  min-width="70%" @click="goPlot()">プロット図</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn  min-width="70%" @click="downloadCsv()">一覧出力</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<Dialog error :open="errorDialog" :ok="()=>errorDialog=false"
      :title="errorTitle" :body="errorMessage"/>
		<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
		<!-- 検索中ダイアログ -->
		<!--<SearchDialog :flg="searching" msg="検索中" />-->
    <Dialog search :open="searching" :cancel="cancelSearch" :width="dialogBkPoint" title="検索中"/>
		<!-- メッセージダイアログ -->
		<v-dialog id="dialog" :width="dialogBkPoint" v-model="dialogFlg" persistent>
			<v-card>
				<v-card-title>検索</v-card-title>
				<v-card-text class="pa-0">
					<v-row align="center" class="ma-1">
						<v-col cols="2" class="pa-0" align="center">
							<v-icon large color="error" class="ma-auto" v-if="dialogCategory == 1">mdi-alert</v-icon>
							<v-icon large color="warning" class="ma-auto" v-if="dialogCategory == 0">mdi-alert</v-icon>
						</v-col>
						<v-col cols="10" style="white-space:break-spaces;">{{ dialogMsg }}</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pt-1">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogFlg = false" v-if="dialogCategory == 0">いいえ</v-btn>
					<v-btn text color="primary" @click="clickOk()">はい</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>
<script>
//import SearchDialog from '../components/SearchDialog.vue'
import Dialog from '../components/Dialog.vue'
import { /*searchExam*/searchExamEx, loadKisai, CallApi } from '../common/apiAccess'
//import { apiUrl } from '../common/utils'

export default {
	name: 'listattr',
	components: {
		//SearchDialog,
		Dialog
	},
	data() {
		return {
      plotVisible: false,
			search: '',
			header: [
				{
					text: '台帳ID',
					value: 'daichoId',
					class:"cyan lighten-3 d-none",
					cellClass: 'd-none'
				},
				{
					text: '申請区分',
					value: 'rcpKubun',
					class:"cyan lighten-3"
				},
				{
					text: '受付番号',
					value: 'rcpNo',
					class:"cyan lighten-3"
				},
				{
					text: '受付日',
					value: 'rcpDate',
					class:"cyan lighten-3"
				},
				{
					text: '確認番号',
					value: 'cnfNo',
					class:"cyan lighten-3"
				},
				{
					text: '確認日',
					value: 'cnfDate',
					class:"cyan lighten-3"
				},
				{
					text: '一般計画区分',
					value: 'ippanKeikaku',
					class:"cyan lighten-3"
				},
				{
					text: '審査状況',
					value: 'examState',
					class:"cyan lighten-3"
				},
				{
					text: '取下げ',
					value: 'drop',
					class:"cyan lighten-3"
				},
				{
					text: '取止め',
					value: 'cancel',
					class:"cyan lighten-3"
				},
				{
					text: '閲覧可否',
					value: 'isBrowse',
					class:"cyan lighten-3"
				},
				{
					text: '地名地番',
					value: 'placeLotNo',
					class:"cyan lighten-3"
				},
				{
					text: '代表建築主氏名',
					value: 'initRepArchitectName',
					class:"cyan lighten-3"
				},
				{
					text: '代表建築主住所',
					value: 'initRepArchitectAddr',
					class:"cyan lighten-3"
				},
			],
			items:[],
			selectedData: null, // 選択されている行のデータ格納用
      // 検索中フラグ
      searching: false,
      // 検索中断コントローラ
      controller: null,
			// エラー表示フラグ
			dialogFlg: false,
			dialogCategory: 1,
			dialogMsg: '',
			apiData: '',
			// メッセージダイアログ
      authDialog: false,
      errorDialog: false,
      errorTitle: '閲覧不可',
      errorMessage: '閲覧できません。',
		}
	},
	computed:{
		mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
		headMessage () {
			return "検索結果";
		},
    kisaiEnable () {
      return this.selectedData && this.selectedData.shubetsu != 1;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
		// ブレークポイント(端末のサイズ・画面サイズ)によって部品のサイズを動的に変える
		dialogBkPoint () {
			switch( this.$vuetify.breakpoint.name) {
				case 'xl':
					return '30%';
				case 'lg':
					return '30%';
				case 'md':
					return '50%';
				case 'sm':
					return '90%';
				case 'xs':
					return '90%';
				default:
					return '30%';
			}
		},
	},
	mounted() {
		if (this.unauthorized) {
			this.authDialog = true;
    }
		this.$store.commit('setCurrentPage', 3);
    this.message = '';
		// 検索結果をセット
    this.items = this.$store.state.attrList;
		// DOMの描画を待って実施
		this.$nextTick(function(){
			if(this.$store.state.listAttrData != null){
				for(let i = 0; i < document.getElementsByTagName('tbody')[0].children.length; i++){
					if(document.getElementsByTagName('tbody')[0].children[i].children[0].innerText == this.$store.state.listAttrData.daichoId){
						document.getElementsByTagName('tbody')[0].children[i].classList.add('light-blue');
						document.getElementsByTagName('tbody')[0].children[i].classList.add('lighten-4');
					}
				}
				this.selectedData = this.$store.state.listAttrData;
			}
		});
	},
	// 詳細検索画面に戻る際に詳細検索結果画面で選択された行の初期化処理
	beforeRouteLeave(to, from, next) {
		if(to.name === 'search-attr' || to.name === 'menu'){
			this.$store.commit('setListAttrData', null);
			next();
		}else{
			next();
		}
	},
	methods: {
    cancelSearch() {
      if (this.controller) {
        this.controller.abort();
      }
      this.searching = false;
    },
		// 検索した際の処理
		searchMod(){
			if(this.selectedData != null){
				for(let i = 0; i < document.getElementsByTagName('tbody')[0].children.length; i++){
					if(this.selectedData.daichoId == document.getElementsByTagName('tbody')[0].children[i].children[0].innerText){
						document.getElementsByTagName('tbody')[0].children[i].classList.add('light-blue');
						document.getElementsByTagName('tbody')[0].children[i].classList.add('lighten-4');
					}
				}
			}
		},
		// テーブル行が選択された時イベント
		clickRow(data) {
			let bodyTableRow = document.getElementsByTagName('tbody')[0];
			// 色削除
			if(this.selectedData != null){
				if(!(bodyTableRow.getElementsByClassName('light-blue').length == 0 && bodyTableRow.getElementsByClassName('lighten-4').length == 0)){
					bodyTableRow.getElementsByClassName('light-blue')[0].classList.remove('light-blue');
					bodyTableRow.getElementsByClassName('lighten-4')[0].classList.remove('lighten-4');
				}
			}
			// 色付け
			for(let i = 0; i < bodyTableRow.children.length; i++){
				if(bodyTableRow.children[i].children[0].innerText == data.daichoId){
					bodyTableRow.children[i].classList.add('light-blue');
					bodyTableRow.children[i].classList.add('lighten-4');
					this.selectedData = data;
				}
			}

		},
		goListExamDisp() {
      if (this.selectedData != null) {
        this.$store.commit('setListAttrData', this.selectedData);
				//const rec = this.items[this.items.indexOf(this.selectedData)];
        const rec = this.selectedData;
        if (rec.kojiId !== undefined) {
          this.searching = true;
          const type = (rec.shubetsu ? rec.shubetsu : 0);
          //this.controller = searchExam(rec.kojiId , (data) => {
          this.controller = searchExamEx(rec.kojiId, type, (data) => {
            this.searching = false;
						if(data.errorCode == 401){
							this.authDialog = true;
						}else if (data !== null && data.length !== undefined) {
              //ToDo: 検索結果が0件のときの処理
              this.$store.commit('setExamList', data);
              this.$router.push('listexamdisp');
            }
            else {
              //ToDo: API呼び出しエラー表示
              console.log(`ListAttr.goListExamDisp() returns ${data.errorCode}:${data.errorDesc}`);
            }
          });
        }
      }
		},
		goBrowseGaiyo() {
      if (this.selectedData && this.selectedData.daichoId) {
        if (!this.selectedData.cnfNo || !this.selectedData.cnfDate) {
          this.errorMessage = '未処分につき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        else if (this.selectedData.drop) {
          this.errorMessage = '取下げにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        else if (this.selectedData.cancel) {
          this.errorMessage = '取止めにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        this.$store.commit('setListAttrData', this.selectedData);
        this.$store.commit('setGaiyoId', this.selectedData.daichoId);
				this.$store.commit('setUkeDay', this.selectedData.rcpDate);
				this.$store.commit('setUkeNo', this.selectedData.RcpNo);
        if (this.selectedData.shubetsu == 1) {         
          this.searching = true;
          this.controller = CallApi('Kosaku', `/${this.selectedData.daichoId}`, (data) => {
            this.searching = false;
            if (data.errorCode) {
              console.log(`${data.errorCode}:${data.errorDesc}`);
            }
            else {
              this.$store.commit('setGaiyoData', data);
              this.$router.push('browsekosaku');
            }
          })
          /*
          this.errorMessage = '築造計画概要書は現在、閲覧できません。';
          this.errorDialog = true;
          */
        }
        else {
          this.$router.push({ name: 'loading', params: { action: 4 }});
        }
      }
		},
		goBrowseDaicho() {
			this.$store.commit('setListAttrData',this.selectedData);
      if (this.selectedData != null) {
        //const rec = this.items[this.items.indexOf(this.selectedData)];
        if (!this.selectedData.cnfNo || !this.selectedData.cnfDate) {
          this.errorMessage = '未処分につき交付できません。';
          this.errorDialog = true;
          return;
        }
        const rec = this.selectedData;
				this.searching = true;
        if (rec.daichoId !== undefined) {
          this.controller = loadKisai(rec.daichoId , (data) => {
            this.searching = false;
						this.apiData = data;
						if(data.errorCode == 401){
							this.authDialog = true;
						}else if (data !== null && data.daichoId !== undefined) {
							if(data.cancel || data.drop || data.unBrowsable || data.unDisposed){
								if(data.cancel){
									this.dialogMsg = '取止めにつき交付できません。\n表示しますか？';
									this.dialogCategory = 0;
									this.dialogFlg = true;
								}else if(data.drop){
									this.dialogMsg = '取下げにつき交付できません。\n表示しますか？';
									this.dialogCategory = 0;
									this.dialogFlg = true;
								}else if(data.unBrowsable){
									this.dialogMsg = '閲覧不可につき交付できません。\n表示しますか？';
									this.dialogCategory = 0;
									this.dialogFlg = true;
								}else if(data.unDisposed){
									this.dialogMsg = '未処分につき交付できません。\n表示しますか？';
									this.dialogCategory = 0;
									this.dialogFlg = true;
								}
							}else{
								this.$store.commit('setKisaiData', data);
								this.$router.push('browsedaicho');
							}
            }
            else {
              //ToDo: API呼び出しエラー表示
              console.log(`ListAttr.goBrowseDaicho(): returns ${data}`);
            }
          });
        }
      }
		},
    // プロット図ジャンプ
    goPlot() {
      if (this.selectedData != null) {
        this.$store.commit('setListAttrData', this.selectedData);
        CallApi('XY', `?uke_no=${this.selectedData.rcpNo}`, (data) => {
          if (data) {
            if (data.errorCode) {
              switch (data.errorCode) {
                case 400:
                  console.log(`error ${data.errorCode}: ${data.errorDesc}`);
                  break;
                case 404:
                  this.errorMessage = '対応する確認プロットが見つかりません。';
                  this.errorDialog = true;
                  break;
                default:
                  console.log(`error ${data.errorCode}: ${data.message}`);
              }
            }
            else if (data.x) {
              this.$store.commit('setCenter', {x:data.x, y:data.y});
              this.$router.push({ name:'map', params:{targetPlot:data, zoom:19} });
            }
          }
        });
      }
    },
		// 一覧出力処理
		downloadCsv(){
			var headerLine = '\ufeff' + 'No,申請区分,受付番号,受付日,確認番号,確認日,一般計画区分,審査状況,取下げ,取止め,閲覧拒否,地名地番,代表建築主氏名,代表建築主住所\n';
			this.items.forEach(function(element, index) {
				var line = (index + 1) + ',' + element['rcpKubun'] + ',' + element['rcpNo'] + ',' + element['rcpDate'] + ',' + element['cnfNo'] + ',' + element['cnfDate'] + ',' + element['ippanKeikaku'] + ',' +
									element['examState'] + ',' + element['drop'] + ',' + element['cancel'] + ',' + element['isBrowse'] + ',' + element['placeLotNo'] + ',' + element['initRepArchitectName'] + ',' + element['initRepArchitectAddr'] + '\n';
				headerLine += line;
			})
			let blob = new Blob([headerLine],{type: 'text/csv'});
			let link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			let now = new Date();
			link.download = now.getFullYear() + ('0' + (now.getMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2) + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()) + '_詳細検索結果一覧.csv';
			link.click();
		},
		// ダイアログクリック処理
		clickOk(){
			this.dialogFlg = false;
			this.$store.commit('setKisaiData', this.apiData);
			this.$router.push('browsedaicho');
		}
	}
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>